import createIcon from '../../createIcon';

/**
 * @component @name NightlightRound
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNTQyNyAxMS45OTk1QzEyLjU0MjcgOC40Mjk1NCAxNC43NDI3IDUuMzc5NTQgMTcuODUyNyA0LjEyOTU0QzE4Ljc0MjcgMy43Njk1NCAxOC42MDI3IDIuNDM5NTQgMTcuNjYyNyAyLjIyOTU0QzE2LjU2MjcgMS45ODk1NCAxNS4zOTI3IDEuOTI5NTQgMTQuMTgyNyAyLjA4OTU0QzkuNjcyNzQgMi42ODk1NCA2LjA2Mjc0IDYuMzk5NTQgNS41OTI3NCAxMC45MTk1QzQuOTcyNzQgMTYuOTI5NSA5LjY2Mjc0IDIxLjk5OTUgMTUuNTQyNyAyMS45OTk1QzE2LjI3MjcgMjEuOTk5NSAxNi45NzI3IDIxLjkxOTUgMTcuNjYyNyAyMS43Njk1QzE4LjYxMjcgMjEuNTU5NSAxOC43NjI3IDIwLjIzOTUgMTcuODYyNyAxOS44Njk1QzE0LjY0MjcgMTguNTc5NSAxMi41MzI3IDE1LjQ1OTUgMTIuNTQyNyAxMS45OTk1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NightlightRound = createIcon('NightlightRound', [
  [
    'path',
    {
      d: 'M12.5427 11.9995C12.5427 8.42954 14.7427 5.37954 17.8527 4.12954C18.7427 3.76954 18.6027 2.43954 17.6627 2.22954C16.5627 1.98954 15.3927 1.92954 14.1827 2.08954C9.67274 2.68954 6.06274 6.39954 5.59274 10.9195C4.97274 16.9295 9.66274 21.9995 15.5427 21.9995C16.2727 21.9995 16.9727 21.9195 17.6627 21.7695C18.6127 21.5595 18.7627 20.2395 17.8627 19.8695C14.6427 18.5795 12.5327 15.4595 12.5427 11.9995Z',
      key: 'dbhmv0',
    },
  ],
]);

export default NightlightRound;
